import { Component, OnInit } from '@angular/core';
import { AuthenticationService } from '../services/authentication.service';
import { ToggleService } from '../services/toggle.service';

@Component({
  selector: 'app-terms-and-policies',
  templateUrl: './terms-and-policies.page.html',
  styleUrls: ['./terms-and-policies.page.scss'],
})
export class TermsAndPoliciesPage implements OnInit {

  constructor(
    public authService: AuthenticationService,
    public toggleService: ToggleService
  ) { }

  ngOnInit() {
    this.toggleService.onResize(null);
  }
}
